<div>
    <div class="chart"  *ngIf="!loading">
        <!-- [ngClass]="{'grid-container': isGrid, 'chart-container': hasChart && !isGrid, 'container': !hasChart, 'text-container': isTextChart}" -->
        <!-- <app-maxis-charts *ngIf="dataLoaded && !hasNoData" [data]="chartData" [config]="maxisChartConfig"
            [isTextCard]="isTextChart" [isGrid]="isGrid" [isArcGauge]="isArcGauge" [isRadialGauge]="isRadialGauge" (click)="openModal()"></app-maxis-charts>
        <max-chart></max-chart> -->
        <max-chart *ngIf="!chartDataError" [chart]="chart.chartData" [hideOwnerInfo]="true" [hideUpdatedInfo]="true" [hideChartId]="true" [gridHeight]="320" [gridWidth]="460" [dialogOnClick]="true"
        [dialogHeight]="(screenHeight / 2) + 50" [dialogWidth]="(screenWidth / 2) + 50" [islightTheme]="true"></max-chart>
        <div class="error-card" *ngIf="chartDataError">
            <div class="header-container">
                <div class="title-container">
                    <div class="title">{{chart.name}}</div>
                    <!-- <div class="subtitle hint-text">{{config.dataUpdatedDate | date: 'MMM d, y - h:mm a'}} using deprecated</div> -->
                </div>
            </div>
            <div class="error-card-description" *ngIf="chartDataError">
                <div class="lock-icon">
                    <mat-icon>error_outline</mat-icon>
                </div>
                There was an unexpected error while retrieving the chart data.
                <div *ngIf="chartDataError === 500 || chartDataError === 403">
                    It looks like the chart has been deleted from Maxis Charts.
                </div>
                <div *ngIf="chartDataError === 404">
                    It looks like our services are experiencing issues, please try again later.
                </div>
            </div>
        </div>
    </div>
</div>